export const Show = {
	name: 'Show',
	props: {
		when: Boolean,
	},
	render(h) {
		return this.when ? this.$slots.default : null;
	}
}
